import { createRole } from '@infuse/api/iam/role';
import { useGenericCreateRole } from './generic/useGenericCreateRole';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { createTenantRole } from '@infuse/api/iam/tenant';
import { createOrganisationRole } from '@infuse/api/iam/organisation';

export const useCreateRole = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericCreateRole({
      apiFn: createTenantRole,
      forcedParentId: user?.tenantId
    });
  } else if (level === UserLevel.ORGANISATION) {
    return useGenericCreateRole({
      apiFn: createOrganisationRole,
      forcedParentId: user?.organisationId
    });
  }

  return useGenericCreateRole({
    apiFn: createRole
  });
};
